import React, { useState } from 'react';
import '../../css/FAQs.css'; // Import the CSS file

const FAQIAATs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What’s the Cognitive Abilities Test (CogAT)?",
      answer: "The CogAT is a test designed to assess your cognitive abilities, including reasoning, problem-solving, and pattern recognition. It helps measure how well you can learn and apply new information."
    },
    {
      question: "Why Should I Take the CogAT?",
      answer: "Taking the CogAT helps identify your strengths in verbal, quantitative, and nonverbal reasoning. It’s often used for placement in gifted programs and to understand your learning potential."
    },
    {
      question: "How Can I Prepare for the CogAT?",
      answer: "Practice is essential! Use prep materials, sample questions, and interactive tools to sharpen your reasoning skills. The more you practice, the more confident you'll feel on test day!"
    },
    {
      question: "When is the Best Time to Take the CogAT?",
      answer: "The CogAT is typically administered at various grade levels. The best time to take it is when you’re prepared to challenge yourself and demonstrate your cognitive strengths."
    },
    {
      question: "What Type of Questions Will I Encounter on the CogAT?",
      answer: "Expect multiple-choice questions that assess verbal, quantitative, and nonverbal reasoning skills. The test measures your ability to recognize patterns, solve problems, and think critically."
    }
  ];


  return (
    <div>
      <h1 className="iaat-title">
        Frequently Asked Questions
      </h1>
      <div className="faq-container">

        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => toggleQuestion(index)}
              style={{ cursor: 'pointer' }}
            >
              {faq.question}
              <span className={`faq-toggle-icon ${openIndex === index ? 'open' : ''}`}>
                {openIndex === index ? '-' : '+'}
              </span>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQIAATs;